<script setup lang="ts">
import { FormattedPercent } from "~/components/ui/FormattedPercent";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const { product } = useProduct();
const { hasBulkPrice, firstBulkUnit, isBulkListPrice, bulkProductUnitLabel } =
  useProductBulkPrices(product);

const bulkProductSavings = computed(
  () => firstBulkUnit.value?.listPrice?.discount * firstBulkUnit.value?.quantity,
);
</script>

<template>
  <div class="flex flex-col">
    <p v-if="hasBulkPrice">
      {{ `${firstBulkUnit?.quantity} ${bulkProductUnitLabel}` }}
    </p>
    <div class="flex flex-row">
      <SharedPrice
        v-if="firstBulkUnit?.totalPrice"
        class="text-left text-base font-medium"
        :discounted="isBulkListPrice"
        :value="firstBulkUnit?.totalPrice"
      />
      <SharedPrice
        v-if="isBulkListPrice"
        class="ml-2 text-base font-normal"
        strikethrough
        :value="firstBulkUnit?.totalPriceWithoutDiscount"
      />
    </div>
    <div v-if="hasBulkPrice && isBulkListPrice" class="flex gap-1 text-sm font-normal">
      <CommonLabel path="BWF/shop/productDetailPage/priceSaving" />
      <SharedPrice v-if="firstBulkUnit?.totalPriceWithoutDiscount" :value="bulkProductSavings" />
      (<FormattedPercent :value="firstBulkUnit?.displayDiscountRate" />)
    </div>
  </div>
</template>
